// ================
// = MobileMenu =
// ================
var ResourceIndexForm = {
  filtered_state_class: "filtered",
  unfiltered_state_class: "unfiltered",
  filtered_state_label: Sparkle.t("views.controls.toggle_label.filtered"),
  unfiltered_state_label: Sparkle.t("views.controls.toggle_label.unfiltered"),

  init: function () {
    ResourceIndexForm.$form = jQuery("#resource_index_form");

    if (ResourceIndexForm.isPresent()) {
      ResourceIndexForm.$filters = jQuery("#filters");
      ResourceIndexForm.$filter_toggle = jQuery("#filter_toggle");
      ResourceIndexForm.register_toggle();
    }

    if (ResourceIndexForm.isFiltered()) {
      ResourceIndexForm.show_filters();
    } else {
      ResourceIndexForm.hide_filters();
    }
  },

  // detects if columns are present
  isPresent: function () {
    if (ResourceIndexForm.$form) {
      return true;
    } else {
      return false;
    }
  },

  isFiltered: function () {
    return ResourceIndexForm.$filters.find('.input[value], :checked, :selected[value!=""]').filter(function () {
      return jQuery(this).val();
    }).length;
  },

  toggle_filters: function () {
    if (ResourceIndexForm.has_filters_visible()) {
      ResourceIndexForm.hide_filters();
    } else {
      ResourceIndexForm.show_filters();
    }
  },

  register_autosubmit: function () {
    jQuery(".controls .search-box").on("keydown", function () {
      if (event.keyCode == 13) {
        this.form.submit();
        return false;
      }
    });
  },

  hide_filters: function () {
    ResourceIndexForm.$filters
      .removeClass(ResourceIndexForm.filtered_state_class)
      .addClass(ResourceIndexForm.unfiltered_state_class);
    ResourceIndexForm.$filter_toggle.text(ResourceIndexForm.unfiltered_state_label);
    ResourceIndexForm.$filters
      .slideUp()
      .find(":input, sp-date-field")
      .not("[type=submit]")
      .attr("disabled", "disabled");
    jQuery("#filter_toggle").removeClass("filters_revealed").addClass("filters_hidden");
  },

  show_filters: function () {
    ResourceIndexForm.$filters
      .removeClass(ResourceIndexForm.unfiltered_state_class)
      .addClass(ResourceIndexForm.filtered_state_class);
    ResourceIndexForm.$filter_toggle.text(ResourceIndexForm.filtered_state_label);
    ResourceIndexForm.$filters.slideDown().find(":input, sp-date-field").removeAttr("disabled");
    jQuery("#filter_toggle").removeClass("filters_hidden").addClass("filters_revealed");
  },

  has_filters_visible: function () {
    return ResourceIndexForm.$filters.hasClass(ResourceIndexForm.filtered_state_class);
  },

  register_toggle: function () {
    if (ResourceIndexForm.has_filters_visible()) {
      ResourceIndexForm.$filters.show();
    }
    ResourceIndexForm.register_autosubmit();
    ResourceIndexForm.$filter_toggle.on("click", function () {
      ResourceIndexForm.toggle_filters();
      return false;
    });
  },
};

jQuery(document).ready(ResourceIndexForm.init);
